export const colorScale: string[] = [
  '#E5E5E5',
  '#E2523F',
  '#E7603A',
  '#EB7436',
  '#EE8A35',
  '#F19E37',
  '#E9A948',
  '#D7B85C',
  '#B9B86B',
  '#7DAE78',
  '#47987F'
];

export const grayScale: string[] = [
  '#f7f7f7',
  '#a1a1a1',
  '#969696',
  '#8c8c8c',
  '#808080',
  '#6b6b6b',
  '#545454',
  '#363636',
  '#1f1f1f',
  '#000000'
];
